import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs/index';
import { PageRules } from './PageRules';
import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';


@Injectable({
  providedIn: 'root',
})
export class JgridService extends BaseService {

  url: string;

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  findPage(url, pageRules: PageRules): Observable<any> {
    this.url = url;
    return this.http.post<any>(this.getUrl() + '/page', pageRules).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return throwError(error.error);
      //return of(result as T);
    };
  }

  public log(message: string) {
    console.log(message);
  }
}
